import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AllProjects({ user, onBack }) {
  const [projects, setProjects] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [filterAdmin, setFilterAdmin] = useState('');

  useEffect(() => {
    loadAdmins();
    loadProjects();
  }, []);

  const loadAdmins = async () => {
    try {
      const res = await axios.get('/api/auth/admins');
      setAdmins(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const loadProjects = async (adminId) => {
    try {
      let url = '/api/projects/all';
      if (adminId) url += '?admin_id=' + adminId;
      const res = await axios.get(url);
      setProjects(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilter = (adminId) => {
    setFilterAdmin(adminId);
    loadProjects(adminId);
  };

  return (
    <div style={styles.container}>
      <div style={styles.pageHeader}>
        <h2>Alle Projekte (Superadmin)</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button style={styles.backBtn} onClick={onBack}>← Zurück zum Dashboard</button>
          <img src="/logo.jpg" alt="EliteHomes" style={styles.logoSmall} />
        </div>
      </div>

      <div style={styles.section}>
        <div style={styles.filterRow}>
          <label style={styles.label}>Filtern nach Admin:</label>
          <select style={styles.filterSelect} value={filterAdmin}
            onChange={e => handleFilter(e.target.value)}>
            <option value="">Alle Admins</option>
            {admins.map(a => (
              <option key={a.id} value={a.id}>{a.email} {a.is_superadmin ? '(Superadmin)' : ''}</option>
            ))}
          </select>
        </div>

        <p style={styles.count}>{projects.length} Projekte gefunden</p>

        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Name</th>
              <th style={styles.th}>Admin</th>
              <th style={styles.th}>Käufer</th>
              <th style={styles.th}>Verkäufer</th>
              <th style={styles.th}>Käufer ✓</th>
              <th style={styles.th}>Verkäufer ✓</th>
              <th style={styles.th}>Erstellt</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(p => (
              <tr key={p.id}>
                <td style={styles.td}>{p.project_uid}</td>
                <td style={styles.td}>{p.name}</td>
                <td style={styles.td}>{p.admin_email}</td>
                <td style={styles.td}>{p.buyer_email || '-'}</td>
                <td style={styles.td}>{p.seller_email || '-'}</td>
                <td style={styles.td}>{p.buyer_submitted ? '✅' : '⏳'}</td>
                <td style={styles.td}>{p.seller_submitted ? '✅' : '⏳'}</td>
                <td style={styles.td}>{new Date(p.created_at).toLocaleDateString('de-CH')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '1200px', margin: '0 auto', padding: '20px', minHeight: '100vh' },
  pageHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  logoSmall: { width: '120px', height: 'auto' },
  backBtn: { padding: '10px 20px', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' },
  section: { backgroundColor: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  filterRow: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' },
  filterSelect: { padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', minWidth: '250px' },
  label: { fontWeight: '600', fontSize: '14px' },
  count: { fontSize: '13px', color: '#666', marginBottom: '12px' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '10px', borderBottom: '2px solid #ddd', backgroundColor: '#f8f9fa', fontSize: '13px' },
  td: { padding: '10px', borderBottom: '1px solid #eee', fontSize: '13px' },
};

export default AllProjects;